<template>
  <div>
    <!-- <span class="spinner-border spinner-border-sm mr-2" role="status" v-if="loading"></span> -->
    <div class="d-flex items-center mb-3">
      <div class="icinfo">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 19C12.1978 19 12.3911 18.9414 12.5556 18.8315C12.72 18.7216 12.8482 18.5654 12.9239 18.3827C12.9996 18.2 13.0194 17.9989 12.9808 17.8049C12.9422 17.6109 12.847 17.4327 12.7071 17.2929C12.5673 17.153 12.3891 17.0578 12.1951 17.0192C12.0011 16.9806 11.8 17.0004 11.6173 17.0761C11.4346 17.1518 11.2784 17.28 11.1685 17.4444C11.0586 17.6089 11 17.8022 11 18C11 18.2652 11.1054 18.5196 11.2929 18.7071C11.4804 18.8946 11.7348 19 12 19ZM17 19C17.1978 19 17.3911 18.9414 17.5556 18.8315C17.72 18.7216 17.8482 18.5654 17.9239 18.3827C17.9996 18.2 18.0194 17.9989 17.9808 17.8049C17.9422 17.6109 17.847 17.4327 17.7071 17.2929C17.5673 17.153 17.3891 17.0578 17.1951 17.0192C17.0011 16.9806 16.8 17.0004 16.6173 17.0761C16.4346 17.1518 16.2784 17.28 16.1685 17.4444C16.0586 17.6089 16 17.8022 16 18C16 18.2652 16.1054 18.5196 16.2929 18.7071C16.4804 18.8946 16.7348 19 17 19ZM17 15C17.1978 15 17.3911 14.9414 17.5556 14.8315C17.72 14.7216 17.8482 14.5654 17.9239 14.3827C17.9996 14.2 18.0194 13.9989 17.9808 13.8049C17.9422 13.6109 17.847 13.4327 17.7071 13.2929C17.5673 13.153 17.3891 13.0578 17.1951 13.0192C17.0011 12.9806 16.8 13.0004 16.6173 13.0761C16.4346 13.1518 16.2784 13.28 16.1685 13.4444C16.0586 13.6089 16 13.8022 16 14C16 14.2652 16.1054 14.5196 16.2929 14.7071C16.4804 14.8946 16.7348 15 17 15ZM12 15C12.1978 15 12.3911 14.9414 12.5556 14.8315C12.72 14.7216 12.8482 14.5654 12.9239 14.3827C12.9996 14.2 13.0194 13.9989 12.9808 13.8049C12.9422 13.6109 12.847 13.4327 12.7071 13.2929C12.5673 13.153 12.3891 13.0578 12.1951 13.0192C12.0011 12.9806 11.8 13.0004 11.6173 13.0761C11.4346 13.1518 11.2784 13.28 11.1685 13.4444C11.0586 13.6089 11 13.8022 11 14C11 14.2652 11.1054 14.5196 11.2929 14.7071C11.4804 14.8946 11.7348 15 12 15ZM19 3H18V2C18 1.73478 17.8946 1.48043 17.7071 1.29289C17.5196 1.10536 17.2652 1 17 1C16.7348 1 16.4804 1.10536 16.2929 1.29289C16.1054 1.48043 16 1.73478 16 2V3H8V2C8 1.73478 7.89464 1.48043 7.70711 1.29289C7.51957 1.10536 7.26522 1 7 1C6.73478 1 6.48043 1.10536 6.29289 1.29289C6.10536 1.48043 6 1.73478 6 2V3H5C4.20435 3 3.44129 3.31607 2.87868 3.87868C2.31607 4.44129 2 5.20435 2 6V20C2 20.7956 2.31607 21.5587 2.87868 22.1213C3.44129 22.6839 4.20435 23 5 23H19C19.7956 23 20.5587 22.6839 21.1213 22.1213C21.6839 21.5587 22 20.7956 22 20V6C22 5.20435 21.6839 4.44129 21.1213 3.87868C20.5587 3.31607 19.7956 3 19 3ZM20 20C20 20.2652 19.8946 20.5196 19.7071 20.7071C19.5196 20.8946 19.2652 21 19 21H5C4.73478 21 4.48043 20.8946 4.29289 20.7071C4.10536 20.5196 4 20.2652 4 20V11H20V20ZM20 9H4V6C4 5.73478 4.10536 5.48043 4.29289 5.29289C4.48043 5.10536 4.73478 5 5 5H6V6C6 6.26522 6.10536 6.51957 6.29289 6.70711C6.48043 6.89464 6.73478 7 7 7C7.26522 7 7.51957 6.89464 7.70711 6.70711C7.89464 6.51957 8 6.26522 8 6V5H16V6C16 6.26522 16.1054 6.51957 16.2929 6.70711C16.4804 6.89464 16.7348 7 17 7C17.2652 7 17.5196 6.89464 17.7071 6.70711C17.8946 6.51957 18 6.26522 18 6V5H19C19.2652 5 19.5196 5.10536 19.7071 5.29289C19.8946 5.48043 20 5.73478 20 6V9ZM7 15C7.19778 15 7.39112 14.9414 7.55557 14.8315C7.72002 14.7216 7.84819 14.5654 7.92388 14.3827C7.99957 14.2 8.01937 13.9989 7.98079 13.8049C7.9422 13.6109 7.84696 13.4327 7.70711 13.2929C7.56725 13.153 7.38907 13.0578 7.19509 13.0192C7.00111 12.9806 6.80004 13.0004 6.61732 13.0761C6.43459 13.1518 6.27841 13.28 6.16853 13.4444C6.05865 13.6089 6 13.8022 6 14C6 14.2652 6.10536 14.5196 6.29289 14.7071C6.48043 14.8946 6.73478 15 7 15ZM7 19C7.19778 19 7.39112 18.9414 7.55557 18.8315C7.72002 18.7216 7.84819 18.5654 7.92388 18.3827C7.99957 18.2 8.01937 17.9989 7.98079 17.8049C7.9422 17.6109 7.84696 17.4327 7.70711 17.2929C7.56725 17.153 7.38907 17.0578 7.19509 17.0192C7.00111 16.9806 6.80004 17.0004 6.61732 17.0761C6.43459 17.1518 6.27841 17.28 6.16853 17.4444C6.05865 17.6089 6 17.8022 6 18C6 18.2652 6.10536 18.5196 6.29289 18.7071C6.48043 18.8946 6.73478 19 7 19Z"
            fill="#84818A"
          />
        </svg>
      </div>
      <div class="row">
        <p class="fs-14 fw-600 mb-0 mt-1">
          {{ $t("circle_feature.lbl_conference_schedule") }}
        </p>
      </div>
    </div>

    <div class="d-flex justify-center mb-3 items-center">
      <div v-if="schedule.length" class="schedule-container">
        <div
          v-for="(item, index) in schedule"
          :key="item.id"
          :class="index < schedule.length - 1 ? 'border-bottom mb-3 pb-3' : ''"
          @click="handleViewSessionDetail(item)"
        >
          <div
            class="group schedule-row d-flex justify-center transition-all duration-300 cursor-pointer"
          >
            <div class="time">
              <p class="font-weight-bold name-of-day txt-grey-900">
                {{ nameOfDay(item.schedule_date) }}
              </p>
              <p
                class="robo-14-700 txt-grey-600 d-flex items-center mb-1 time-el"
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 22 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M11 2C9.02219 2 7.08879 2.58649 5.4443 3.6853C3.79981 4.78412 2.51809 6.3459 1.76121 8.17317C1.00433 10.0004 0.806299 12.0111 1.19215 13.9509C1.578 15.8907 2.53041 17.6725 3.92894 19.0711C5.32746 20.4696 7.10929 21.422 9.0491 21.8079C10.9889 22.1937 12.9996 21.9957 14.8268 21.2388C16.6541 20.4819 18.2159 19.2002 19.3147 17.5557C20.4135 15.9112 21 13.9778 21 12C21 10.6868 20.7413 9.38642 20.2388 8.17317C19.7363 6.95991 18.9997 5.85752 18.0711 4.92893C17.1425 4.00035 16.0401 3.26375 14.8268 2.7612C13.6136 2.25866 12.3132 2 11 2ZM11 20C9.41775 20 7.87104 19.5308 6.55544 18.6518C5.23985 17.7727 4.21447 16.5233 3.60897 15.0615C3.00347 13.5997 2.84504 11.9911 3.15372 10.4393C3.4624 8.88743 4.22433 7.46197 5.34315 6.34315C6.46197 5.22433 7.88743 4.4624 9.43928 4.15372C10.9911 3.84504 12.5997 4.00346 14.0615 4.60896C15.5233 5.21447 16.7727 6.23984 17.6518 7.55544C18.5308 8.87103 19 10.4177 19 12C19 14.1217 18.1572 16.1566 16.6569 17.6569C15.1566 19.1571 13.1217 20 11 20ZM11 6C10.7348 6 10.4804 6.10536 10.2929 6.29289C10.1054 6.48043 10 6.73478 10 7V11.42L7.9 12.63C7.70736 12.7392 7.5564 12.9092 7.47078 13.1134C7.38517 13.3176 7.36975 13.5444 7.42695 13.7583C7.48414 13.9722 7.61072 14.1611 7.78682 14.2953C7.96292 14.4296 8.17859 14.5015 8.4 14.5C8.57518 14.5012 8.7476 14.4564 8.9 14.37L11.5 12.87L11.59 12.78L11.75 12.65C11.7891 12.6005 11.8226 12.5468 11.85 12.49C11.8826 12.4363 11.9094 12.3793 11.93 12.32C11.9572 12.2564 11.9741 12.1889 11.98 12.12L12 12V7C12 6.73478 11.8946 6.48043 11.7071 6.29289C11.5196 6.10536 11.2652 6 11 6Z"
                    fill="#667085"
                  />
                </svg>
                {{ formatTime(item.schedule_date) }}-{{
                  calculateEstimateEndtime(
                    formatTime(item.schedule_date),
                    item.duration
                  )
                }}
              </p>
              <p
                class="robo-14-700 txt-grey-600 mb-1 d-flex items-center time-el"
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 22 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M21 14H20V4H21C21.2652 4 21.5196 3.89464 21.7071 3.70711C21.8946 3.51957 22 3.26522 22 3C22 2.73478 21.8946 2.48043 21.7071 2.29289C21.5196 2.10536 21.2652 2 21 2H3C2.73478 2 2.48043 2.10536 2.29289 2.29289C2.10536 2.48043 2 2.73478 2 3C2 3.26522 2.10536 3.51957 2.29289 3.70711C2.48043 3.89464 2.73478 4 3 4H4V14H3C2.73478 14 2.48043 14.1054 2.29289 14.2929C2.10536 14.4804 2 14.7348 2 15C2 15.2652 2.10536 15.5196 2.29289 15.7071C2.48043 15.8946 2.73478 16 3 16H11V17.15L6.45 20.15C6.26333 20.2655 6.11988 20.4393 6.04177 20.6445C5.96366 20.8496 5.95523 21.0748 6.01779 21.2852C6.08035 21.4957 6.21042 21.6797 6.38793 21.8089C6.56544 21.938 6.78053 22.0052 7 22C7.1966 22.0022 7.38896 21.9428 7.55 21.83L11 19.55V21C11 21.2652 11.1054 21.5196 11.2929 21.7071C11.4804 21.8946 11.7348 22 12 22C12.2652 22 12.5196 21.8946 12.7071 21.7071C12.8946 21.5196 13 21.2652 13 21V19.55L16.45 21.83C16.611 21.9428 16.8034 22.0022 17 22C17.2136 21.9984 17.4212 21.9283 17.5921 21.8002C17.7631 21.672 17.8885 21.4925 17.95 21.2879C18.0115 21.0832 18.0058 20.8643 17.9338 20.6631C17.8619 20.462 17.7273 20.2892 17.55 20.17L13 17.17V16H21C21.2652 16 21.5196 15.8946 21.7071 15.7071C21.8946 15.5196 22 15.2652 22 15C22 14.7348 21.8946 14.4804 21.7071 14.2929C21.5196 14.1054 21.2652 14 21 14ZM18 14H6V4H18V14ZM9.61 12.26C9.87653 12.4175 10.1804 12.5005 10.49 12.5005C10.7996 12.5005 11.1035 12.4175 11.37 12.26L14.37 10.52C14.6265 10.3626 14.8383 10.142 14.9852 9.87943C15.1322 9.61683 15.2093 9.32093 15.2093 9.02C15.2093 8.71907 15.1322 8.42317 14.9852 8.16057C14.8383 7.89796 14.6265 7.67741 14.37 7.52L11.37 5.78C11.1035 5.62253 10.7996 5.53946 10.49 5.53946C10.1804 5.53946 9.87653 5.62253 9.61 5.78C9.34143 5.9314 9.11879 6.15259 8.96564 6.42017C8.81248 6.68774 8.73452 6.99174 8.74 7.3V10.78C8.74167 11.0815 8.82302 11.3772 8.97581 11.6371C9.1286 11.897 9.34739 12.1119 9.61 12.26ZM10.74 7.68L13 9L10.72 10.32L10.74 7.68Z"
                    fill="#667085"
                  />
                </svg>
                {{ formatDate(item.schedule_date) }}
              </p>
              <p
                class="robo-14-700 txt-grey-600 d-flex items-center mb-1 time-el"
              >
                <svg
                  width="20"
                  height="20"
                  fill="none"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M159.707429 246.290286c6.436571 0 11.154286-0.859429 17.152-5.577143l143.561142-108.434286c7.296-5.12 11.154286-11.995429 11.154286-19.273143 0-8.996571-4.297143-16.274286-11.574857-23.149714-16.274286-14.573714-45.44-22.710857-71.131429-22.710857a119.716571 119.716571 0 0 0-120.448 120.429714c0 15.853714 2.578286 31.707429 6.857143 41.563429 4.717714 10.715429 14.153143 17.152 24.429715 17.152z m704.146285 0c10.715429 0 19.291429-6.857143 24.429715-17.152 4.717714-9.417143 7.277714-25.709714 7.277714-41.563429 0-66.852571-53.577143-120.429714-120.850286-120.429714-25.289143 0-54.418286 8.137143-70.710857 22.710857-7.296 6.857143-11.574857 14.153143-11.574857 23.149714 0 7.277714 3.858286 14.134857 10.715428 19.273143l143.579429 108.434286c5.997714 4.717714 10.715429 5.577143 17.133714 5.577143zM153.270857 943.579429a33.005714 33.005714 0 0 0 47.579429-0.438858l67.712-67.291428A409.216 409.216 0 0 0 512 956.013714c91.282286 0 175.286857-29.988571 243.419429-80.146285l67.730285 67.291428c13.275429 13.714286 34.285714 13.714286 47.140572 0.438857 12.434286-12.434286 12.854857-33.426286-0.438857-46.299428l-65.133715-64.713143a407.222857 407.222857 0 0 0 116.992-286.281143C921.709714 320 738.285714 136.137143 512 136.137143c-226.285714 0-409.709714 183.862857-409.709714 410.148571a408.685714 408.685714 0 0 0 116.571428 286.281143l-65.152 64.731429c-12.854857 12.854857-12.854857 33.828571-0.420571 46.262857zM512 882.724571c-186.002286 0-336.859429-150.436571-336.859429-336.438857 0-185.563429 150.857143-336.420571 336.859429-336.420571 185.563429 0 336 150.857143 336 336.420571 0 186.002286-150.436571 336.420571-336 336.420572z m-194.998857-289.28h194.56c16.731429 0 30.006857-12.873143 30.006857-29.586285V304.146286a29.805714 29.805714 0 0 0-29.988571-29.988572c-16.731429 0-29.586286 13.275429-29.586286 29.988572v229.705143h-164.992c-17.152 0-29.988571 13.293714-29.988572 29.988571 0 16.731429 12.836571 29.586286 29.988572 29.586286z"
                    fill="#667085"
                  />
                </svg>
                {{ displayDuration(item.duration) }}
              </p>
            </div>
            <div class="body flex-1">
              <!-- <div class="btn-group top-0" @click.stop="handleAddReminder(item)">
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="$t('Đặt thông báo nhắc nhở trên Google Calendar')"
                  placement="top"
                >
                  <div
                    class="flex w-8 h-8 cursor-pointer rounded-md bg-blue-100 hover:bg-blue-300 transition-all duration-300"
                  >
                    <i class="el-icon-date m-auto text-lg" />
                  </div>
                </el-tooltip>
              </div>-->
              <p
                class="fs-24 fw-600 max-line-2 txt-pri group-hover:text-blue-500 transition-all duration-300 title mr-18"
              >
                {{ getDataLang(item).title }}
              </p>
              <p class="fs-24 fw-600 max-line-2 txt-pri title mr-18 labels">
                <span
                  class="text-white fs-12"
                  :class="getStatus(item.status).class"
                  >{{ getStatus(item.status).text }}</span
                >
              </p>
              <p class="description">{{ getDataLang(item).introduction }}</p>
              <div class="d-flex">
                <div style="width: -webkit-fill-available">
                  <p
                    class="fs-14 fw-600 mb-2 mt-1 mr-3"
                    v-if="isHasSpeakers(item.circle_schedule_speakers)"
                  >
                    {{ $t("conference.lbl_speaker") }}:
                  </p>
                  <div class="row">
                    <div
                      v-for="presenter in item.circle_schedule_speakers"
                      :key="presenter.id"
                      :set="(mem = presenter.user_speaker)"
                      class="col-4 d-flex align-items-center mb-2"
                      @click="goToProfile(presenter.user_speaker)"
                    >
                      <div v-if="mem">
                        <!-- <span
                          v-if="mem&&mem.avatar"
                          class="avatar avatar-sm avatar-rounded bg-top"
                          :style="
                          'background-image: url(' +
                          getImageURL(mem.avatar) +
                          ')'
                        "
                        ></span>-->
                        <ImageBox
                          v-if="mem && mem.avatar"
                          class="avatar avatar-sm avatar-rounded object-cover object-top border"
                          avatar
                          :source="getImageURL(mem.avatar)"
                          :alt="
                            getMultilangValue(
                              presenter.user_speaker.speaker_multi_language
                            )
                              ? getMultilangValue(
                                  presenter.user_speaker.speaker_multi_language
                                ).name
                              : mem.name
                          "
                        />
                        <span
                          v-if="mem && !mem.avatar"
                          class="avatar avatar-sm avatar-rounded bg-pri text-white"
                        >
                          {{ mem.name.charAt(0) || mem.email.charAt(0) }}
                        </span>
                      </div>
                      <div
                        v-if="mem"
                        class="d-flex flex-col flex-1 justify-center pl-2"
                      >
                        <p class="fs-14 fw-600 txt-black mb-0">
                          {{
                            getMultilangValue(
                              presenter.user_speaker.speaker_multi_language
                            )
                              ? getMultilangValue(
                                  presenter.user_speaker.speaker_multi_language
                                ).name
                              : mem.name
                          }}
                        </p>
                        <p
                          v-if="mem.doctor_infor && mem.doctor_infor.chuc_vu"
                          class="fs-12 fw-500 txt-grey-600 mb-0"
                        >
                          {{
                            getMultilangValue(
                              presenter.user_speaker.speaker_multi_language
                            )
                              ? getMultilangValue(
                                  presenter.user_speaker.speaker_multi_language
                                ).job_title
                              : mem.doctor_infor && mem.doctor_infor.chuc_vu
                          }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="!schedule.length"
        class="d-flex justify-center flex-col mb-3 items-center"
      >
        <p>Hiện tại, không có lịch hội nghị. Xin vui lòng quay lại sau.</p>
      </div>
    </div>
    <ModalEditSessionSchedule @refresh="fetchLivestreamSchedule" />
  </div>
</template>

<script>
import mdtUtils from '@/utils/mdtUtils'
import appUtils from '@/utils/appUtils.js'
import { LANGUAGE_CODES_FOR_DISEASE } from '@/lang'
import CustomModal from '@/components/CustomModal'
import ReportDetail from '@/pages/Conference/ReportDetail.vue'
import ModalEditSessionSchedule from '@/components/Conference/Modal/ModalEditSessionSchedule.vue'
import ImageBox from '@/components/Common/Image.vue'

export default {
  name: 'ConferenceCircleSession',
  components: {
    CustomModal,
    ReportDetail,
    ModalEditSessionSchedule,
    ImageBox
  },
  data () {
    return {
      specialist_members: [],
      schedule: [],
      scheduleSelected: {},
      loading: false,
      mdtUtils,
      showReportDetail: false,
      reportData: {},
      appUtils
    }
  },
  props: ['isAdmin', 'seedMember'],
  computed: {
    lang () {
      return LANGUAGE_CODES_FOR_DISEASE[this.$lang.toUpperCase()]
    }
  },
  created () {
    this.fetchSpecialistMembers()
    this.fetchLivestreamSchedule()
  },
  methods: {
    async fetchLivestreamSchedule () {
      this.loading = true
      await this.$rf
        .getRequest('CommonRequest')
        .fetchLivestreamSchedule({
          circle_id: Number(this.$route.params?.id || this.$route.query?.id),
          sort_by: 'schedule_date',
          order: 'asc',
          page_size: 10000,
          page_num: 1
        })
        .then((res) => {
          this.schedule = res.data.data

          const lastSchedule = this.schedule?.[this.schedule?.length - 1]
          this.$emit('setLastSchedule', lastSchedule)

          this.loading = false
        })
        .catch((e) => {
          this.loading = false
          console.log(e)
        })
    },
    getStatus (status) {
      switch (status) {
        case 1:
          return {
            text: this.$t('circle_feature.lbl_draft_schedule'),
            class: 'draft'
          }
        case 2:
          return {
            text: this.$t('circle_feature.lbl_public_schedule'),
            class: 'public'
          }
        case 3:
          return {
            text: this.$t('circle_feature.lbl_live_now'),
            class: 'ongoing'
          }
        default:
          return {
            text: this.$t('circle_feature.lbl_draft_schedule'),
            class: 'draft'
          }
      }
    },
    nameOfDay (date) {
      return mdtUtils.getNameOfDay(window.moment(date).day(), this.$lang)
    },
    formatDate (date) {
      return window.moment(date).format('DD-MM-YYYY')
    },
    formatTime (date_time) {
      return window.moment(date_time).format('HH:mm')
    },
    formatDateTime (date_time) {
      return window.moment(date_time).format('YYYY-MM-DD HH:mm:ss')
    },
    convertTotalMinutesToHHMM (totalMinutes) {
      let hours = Math.floor(totalMinutes / 60)
      let minutes = totalMinutes % 60
      if (hours < 10) hours = '0' + hours
      if (minutes < 10) minutes = '0' + minutes
      return hours + ':' + minutes
    },
    displayDuration (totalMinutes) {
      return this.$t('conference.fm_minutes', { minutes: totalMinutes })
    },
    calculateEstimateEndtime (datetime, plusMinute) {
      let [hours, minutes] = datetime.split(':')
      let totalMinutes = hours * 60 + +minutes
      totalMinutes += +plusMinute
      return this.convertTotalMinutesToHHMM(totalMinutes)
    },
    async fetchSpecialistMembers () {
      const self = this
      await self.$rf
        .getRequest('DoctorRequest')
        .getLiveCircleMembers({
          status: 2, // đã join circle
          role: 2,
          page_num: 1,
          page_size: 10000,
          circle_id: Number(self.$route.params?.id || self.$route.query?.id)
        })
        .then((r) => {
          const seedMember = {
            id: self.seedMember.id,
            user_id: self.seedMember.doctor.user_id,
            isSeed: 1,
            user_info: {
              ...self.seedMember,
              doctor_infor: self.seedMember.doctor
            }
          }
          self.specialist_members = [seedMember, ...r.data.data]
        })
        .catch((e) => {
          console.log(e)
          self.$toast.open({
            message: self.$t('circle_feature.lbl_permission_msg'),
            type: 'warning'
          })
        })
    },
    getListSpecialistOfEachSchedule (circle_schedule_speakers) {
      let arr = []
      circle_schedule_speakers?.length &&
        circle_schedule_speakers.forEach((speaker) => {
          let presenter = this.specialist_members.find(
            (mem) => mem.user_id === speaker.user_id
          )
          if (presenter) {
            arr.push({
              ...presenter,
              user_speaker: speaker.user_speaker
            })
          }
        })
      return arr
    },
    handleAddReminder (item) {
      console.log(item)
    },
    getImageURL (avatar) {
      if (avatar.includes('https')) return avatar
      return appUtils.getImageURL(avatar)
    },
    goToProfile (data) {
      const doctorId = data?.doctor_infor?.id
      if (!doctorId) return
      this.$router
        .push({ name: 'DoctorProfile', params: { id: doctorId } })
        .catch(() => {})
    },
    handleViewSessionDetail (item) {
      if (Number(this.$route.params?.id)) {
        this.$router
          .push({
            name: 'WorkspaceConferenceSessionDetail',
            params: {
              id: Number(this.$route.params?.id),
              sessionId: item.id
            }
          })
          .catch(() => {})
      } else {
        this.$emit('handleViewSessionDetail', item)
      }
    },
    getDataLang (item) {
      const langValue = this.lang
      const langData =
        item?.pape_multilanguage?.find((paper) => paper?.lang === langValue) ||
        {}
      return langData
    },
    getMultilangValue (data) {
      if (!data) return ''
      return data.find((item) => (item.Lang || item.lang) === this.lang)
    },
    hideModal () {
      this.showReportDetail = false
      this.reportData = null
      const { id, ...newQuery } = this.$route.query
      this.$router
        .replace({
          query: newQuery
        })
        .catch(() => {})
    },
    isHasSpeakers (circle_schedule_speakers) {
      if (!circle_schedule_speakers?.length) return false
      return true
    }
  }
}
</script>

<style lang="scss" scoped>
.icinfo {
  margin-right: 16px;
}

.btn-create-schedule {
  display: flex;
  align-items: center;
  border-radius: 10px;
  border: 1px dashed #20419b;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #20419b;
  padding: 8px;
  margin: 0 auto 30px auto;
  cursor: pointer;
  justify-content: center;
}

// Livestream schedule
.schedule-container {
  width: 100%;
  max-height: 500px;
  overflow-y: auto;
  overflow-x: hidden;
  > div {
    &:last-child hr {
      margin-bottom: 0px;
    }
    hr {
      margin: 1rem 0;
    }
  }
  .schedule-row {
    gap: 15px;
    .time {
      //  min-width: 150px;
      white-space: nowrap;
      .time-el {
        gap: 5px;
        svg {
          transform: translateY(-2px);
        }
      }
      p {
        margin-bottom: 0px;
      }
      .name-of-day {
        font-size: 25px;
        text-transform: capitalize;
      }
    }
    .body {
      width: -webkit-fill-available;
      position: relative;
      border-left: 1px solid #e0e0e0;
      padding-left: 16px;
      .btn-group {
        top: 5px;
        right: 8px;
        position: absolute;
      }
      p {
        margin-bottom: 5px;
      }
      .title {
        &.labels {
          line-height: 21px;
        }
        span {
          display: inline-block;
          text-wrap: nowrap;
          border-radius: 15px;
          padding: 2px 10px;
        }
        .draft {
          background-color: rgb(0, 195, 255);
        }
        .public {
          background-color: #00b135;
        }
        .ongoing {
          background-color: red;
        }
      }
      .avatars {
        .avatar {
          --tblr-avatar-size: 2rem;
        }
      }
    }
  }
}
</style>>
